import React from "react";
import { createRoot } from "react-dom/client";
import { unregister } from "./registerServiceWorker";
import { IntlProvider } from "react-intl";
import App from "./app";
import localeLanguageSv from "./i18n/sv.json";
import localeLanguageEn from "./i18n/en.json";

var language = window.navigator.userLanguage || window.navigator.language;

if (language !== "sv" && language !== "en") {
  language = "sv";
}

let i18nConfig;

switch (language) {
  case "sv":
    i18nConfig = localeLanguageSv;
    break;
  case "en":
    i18nConfig = localeLanguageEn;
    break;
  default:
    i18nConfig = localeLanguageSv;
    break;
}
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <div>
    <IntlProvider locale={i18nConfig.locale} messages={i18nConfig.messages}>
      <App />
    </IntlProvider>{" "}
  </div>
);

unregister();
